"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SurveyResultsPagingCard = void 0;
const adaptivecards_1 = require("adaptivecards");
const components_1 = require("../../_shared/components");
const DetailsBar_1 = require("../../_shared/components/DetailsBar");
const CardHelper_1 = require("../../_shared/utils/CardHelper");
const DoneAction_1 = require("../actions/DoneAction");
const PreviousQuestionAction_1 = require("../actions/PreviousQuestionAction");
const commands_1 = require("../commands");
const QuestionResults_1 = require("./QuestionResults");
const SurveyCommentsCard_1 = require("./SurveyCommentsCard");
const SurveyResultsPagingCard = (survey, responses, autolinkIntegrations, ordinal = 0, currentUserId) => {
    const card = CardHelper_1.CardHelper.newCard();
    card.addItem(renderDetailTitleBar(survey));
    const questionContainer = CardHelper_1.CardHelper.create(adaptivecards_1.Container, {
        style: adaptivecards_1.ContainerStyle.Emphasis,
    });
    const currentQuestion = survey.questions[ordinal];
    questionContainer.addItem((0, QuestionResults_1.QuestionResults)(currentQuestion, responses, survey.anonymity, survey.applicationType, {
        showTitle: survey.type !== "poll",
        hideSettings: survey.type === "agile-standup",
        autolinkIntegrations,
        currentUserId,
    }));
    card.addItem(questionContainer);
    const commentsContainer = renderQuestionCommentContainer(responses, currentQuestion);
    if (commentsContainer) {
        card.addItem(commentsContainer);
    }
    if (survey.type !== "poll") {
        card.addItem((0, components_1.PageIndicator)(survey.id, ordinal, survey.questions.length, (surveyId, pageNumber) => {
            return CardHelper_1.CardHelper.create(adaptivecards_1.SubmitAction, {
                data: (0, commands_1.SurveyResultsViewCommand)(surveyId, {
                    questionOrdinal: pageNumber,
                }).toTaskFetchCommand(),
            });
        }, survey.applicationType));
    }
    else if (survey.type === "poll" && survey.questions[0].questionType !== "open-ended") {
        //Open ended surveys do not have comments
        if (survey.commentsEnabled) {
            const commentsContainer = (0, SurveyCommentsCard_1.SurveyCommentsContainer)(responses);
            commentsContainer.spacing = adaptivecards_1.Spacing.Large;
            commentsContainer.style = adaptivecards_1.ContainerStyle.Emphasis;
            card.addItem(commentsContainer);
        }
    }
    renderActionBar(card, ordinal, survey, responses.some(r => r.comments.length > 0));
    return card;
};
exports.SurveyResultsPagingCard = SurveyResultsPagingCard;
const renderDetailTitleBar = (survey) => {
    const container = CardHelper_1.CardHelper.create(adaptivecards_1.Container);
    const detailBar = (0, DetailsBar_1.detailsBar)(survey, {
        separator: false,
        spacing: adaptivecards_1.Spacing.Small,
    });
    container.addItem(detailBar);
    container.addItem(CardHelper_1.CardHelper.create(adaptivecards_1.TextBlock, {
        text: (0, CardHelper_1.getSurveyTitleDisplay)(survey),
        size: adaptivecards_1.TextSize.Large,
        weight: adaptivecards_1.TextWeight.Bolder,
        wrap: true,
    }));
    return container;
};
const renderActionBar = (card, ordinal, survey, hasSurveyComments) => {
    const nextQuestion = survey.questions[ordinal + 1];
    const prevQuestion = survey.questions[ordinal - 1];
    if (prevQuestion) {
        card.addAction((0, PreviousQuestionAction_1.PreviousQuestionAction)(survey.id, ordinal - 1));
    }
    if (nextQuestion) {
        const submitAction = CardHelper_1.CardHelper.create(adaptivecards_1.SubmitAction, {
            // NOTE: if this text is changed, make sure to change the text in Polly preview as well.
            title: "Next ❯",
            isPrimary: false,
            data: (0, commands_1.SurveyResultsViewCommand)(survey.id, {
                questionOrdinal: ordinal + 1,
            }).toTaskFetchCommand(),
        });
        card.addAction(submitAction);
    }
    else if (survey.commentsEnabled || hasSurveyComments) {
        const commentAction = CardHelper_1.CardHelper.create(adaptivecards_1.SubmitAction, {
            title: "Comments",
            isPrimary: true,
            data: (0, commands_1.SurveyResultsViewCommand)(survey.id, { surveyComments: true }).toTaskFetchCommand(),
        });
        card.addAction(commentAction);
    }
    card.addAction((0, DoneAction_1.DoneAction)());
};
const renderQuestionCommentContainer = (responses, question) => {
    const container = CardHelper_1.CardHelper.create(adaptivecards_1.Container, {
        spacing: adaptivecards_1.Spacing.Large,
        style: adaptivecards_1.ContainerStyle.Emphasis,
    });
    const commentItemListContainer = CardHelper_1.CardHelper.create(adaptivecards_1.Container, {
        separator: true,
        spacing: adaptivecards_1.Spacing.Large,
    });
    for (const userSurveyResponse of responses) {
        const userQuestionResponse = userSurveyResponse.responses.find(response => response.questionId === question.id);
        if (!(userQuestionResponse === null || userQuestionResponse === void 0 ? void 0 : userQuestionResponse.comment)) {
            continue;
        }
        const commentItem = {
            name: userSurveyResponse.user.name,
            comment: userQuestionResponse.comment,
            timestamp: userQuestionResponse.updatedAt || userQuestionResponse.createdAt,
        };
        const itemContainer = (0, components_1.UserDiscourseItem)(commentItem);
        commentItemListContainer.addItem(itemContainer);
    }
    const commentCount = commentItemListContainer.getItemCount();
    if (commentCount === 0) {
        return null;
    }
    container.addItem(CardHelper_1.CardHelper.create(adaptivecards_1.TextBlock, {
        text: `💬 Comments (${commentCount})`,
        size: adaptivecards_1.TextSize.Large,
        weight: adaptivecards_1.TextWeight.Bolder,
    }));
    container.addItem(commentItemListContainer);
    return container;
};
//# sourceMappingURL=SurveyResultPagingCard.js.map